import { Component, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormArray, FormControl, FormGroupDirective, ControlContainer } from '@angular/forms';
import { JurisDictionCode, Hash, ClientFileScheduleAndContractInfoModel } from '@core/services/client/client.model';
import { Observable } from 'rxjs';
import { AuthService } from '@core/services/auth/auth.service';
import { ClientfileschedulesService } from '@core/services/client/clientfileschedules.services';
import { TimeCompareAsyncValidator } from '../../components/clientid-async-validator';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'Teranet-Clientfileschedule',
  templateUrl: './clientfileschedule.component.html',
  styleUrls: ['./clientfileschedule.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class ClientFileScheduleComponent implements OnInit {

  @Input() ClientId: number;
  @Input() Readonly: boolean;
  @Input() filescheduleform: FormGroup;
  @Input() processstatuses: Array<Hash[]>;

  clientfileschedulearray = new FormArray([]);
  selectedFileSchedule$: Observable<ClientFileScheduleAndContractInfoModel>;
  fileschedule: ClientFileScheduleAndContractInfoModel;
  filedescriptions: Hash[];
  duplicatereferencechecks: any;

  Jurisdictioncodes: JurisDictionCode[];
  jurisdictioncodes: string[];
  urgencys: Hash[];
  impacts: Hash[];
  filestatuses: Hash[];
  FileSchedule_step = -1;
  Contract_step = -1;

  selectedFiledescriptionData: any;
  selectedprocessstatusesData: any;
  selectedjurisdictioncodesData: any;

  selectedfilestatusesnData: any;

  constructor(private parent: FormGroupDirective, public auth: AuthService, private clientfileschedulesService: ClientfileschedulesService, private route: ActivatedRoute) {
   
  }
  ngOnInit() {

    this.parent.form.addControl('clientfilescheduleiInfolist', this.clientfileschedulearray);
    this.clientfileschedulearray.setParent(this.parent.form);
    this.route.queryParams.subscribe(value => {
      if (value) {
        if (value['id'] as number >= 0) {
          this.ClientId = value['id'] as number;
        }
        else {
          this.ClientId = -1;
        }
      }
    });
  
    setTimeout(() => {
      this.clientfileschedulesService.GetDuplicateRefChecks().subscribe(
        duprefsearch => {this.duplicatereferencechecks = duprefsearch});
      this.clientfileschedulesService.CallFilestatus()
        .subscribe(filestatuse => { this.filestatuses = filestatuse as Hash[] });
      this.clientfileschedulesService.CallFileDescriptionapi(this.ClientId)
        .subscribe(filedescription => { this.filedescriptions = filedescription as Hash[] });   
        this.clientfileschedulesService.GetJurisdictionCode().subscribe(jurisdictioncode => { this.jurisdictioncodes = jurisdictioncode as string[] });
        this.clientfileschedulesService.GetUrgency().subscribe(urgency => { this.urgencys = urgency as Hash[] });
        this.clientfileschedulesService.GetImpact().subscribe(impact => { this.impacts = impact as Hash[] });
    }, 1000);

    for (var i = 0; i < this.clientfileschedulearray.length; i++) {
      this.formControlValueChanged(i);
    }
  }



  setFileScheduleStep(index: number) {
    this.FileSchedule_step = index;
  }

  setContractInfoStep(index: number) {
    this.Contract_step = index;
  }

  getProcessStatus(clientfileinfoid: number, n: number) {
    this.clientfileschedulesService.CallProcessStatuses(clientfileinfoid)
      .subscribe(data => {
        this.processstatuses[n] = data;
      });
  }

  public formControlValueChanged(i: number) {

    console.log("clientfileinfoid", i);
    this.fileschedules.controls[i].get('clientfileinfoid').valueChanges.subscribe(
      (mode: string) => {
        console.log("clientfileinfoid", i);
        this.getProcessStatus(this.fileschedules.controls[i].get('clientfileinfoid').value, i);
      });


    const expectedresettimeControl = this.fileschedules.controls[i].get('expectedresettime');

    console.log("clientfileschedulearray" + i, this.processstatuses[i]);

    this.fileschedules.controls[i].get('expectedresettime').valueChanges.subscribe(
      (mode: string) => {
        console.log('mode', mode);
        //expectedresettimeControl.setValidators(TimeCompareAsyncValidator(this.fileschedules.controls[i].get('expectedstarttime').value));
        expectedresettimeControl.updateValueAndValidity({ emitEvent: false });
      });

    this.fileschedules.controls[i].get('expectedstarttime').valueChanges.subscribe(
      (mode: string) => {
        console.log('mode', mode);
        //expectedresettimeControl.setValidators(TimeCompareAsyncValidator(this.fileschedules.controls[i].get('expectedstarttime').value));
        expectedresettimeControl.updateValueAndValidity({ emitEvent: false });
      });
  }

  get fileschedules(): FormArray { return this.parent.form.get('clientfilescheduleiInfolist') as FormArray; }

  addClientFileInfo() {

    this.fileschedules.push(this.filescheduleform);
    this.formControlValueChanged(this.fileschedules.length - 1);
    this.setFileScheduleStep(this.fileschedules.length - 1);
  }


  removeClientFileInfo(i: number) {
    this.fileschedules.removeAt(i);
    this.setFileScheduleStep(i - 1);
  }


  filedescriptionselected(event) {
    let target = event.source.selected._element.nativeElement;
    this.selectedFiledescriptionData = {
      value: event.value,
      text: target.innerText.trim()
    };
    console.log(this.selectedFiledescriptionData);
  }

  jurisdictioncodeselected(event) {
    let target = event.source.selected._element.nativeElement;
    this.selectedjurisdictioncodesData = {
      value: event.value,
      text: target.innerText.trim()
    };
    console.log(this.selectedjurisdictioncodesData);
  }

  processstatusesselected(event) {
    let target = event.source.selected._element.nativeElement;
    this.selectedprocessstatusesData = {
      value: event.value,
      text: target.innerText.trim()
    };
    console.log(this.selectedprocessstatusesData);
  }

  fileStatussselected(event) {
    let target = event.source.selected._element.nativeElement;
    this.selectedfilestatusesnData = {
      value: event.value,
      text: target.innerText.trim()
    };
    console.log(this.selectedfilestatusesnData);
  }


  GetDescription(id: string): string {
    if (this.filedescriptions && id.toString() != "") {
      if (this.filedescriptions.find(x => x.id == Number(id))) {
        return this.filedescriptions.find(x => x.id == Number(id)).description.toString();
      }

    }
    return "";

  }



  HasDescription_FileSchedule(i: number): boolean {
    if (this.GetDescription(this.fileschedules.controls[i].get('clientfileinfoid').value.toString()) != "" && i < this.fileschedules.length) {
      return true;
    }
    return false;
  }



}
